<m-input-style class="m-textfield"
               :class="[{ 'm--has-word-wrap': hasWordWrap }, 'm--is-type-' + inputType ]"
               :disabled="isDisabled"
               :waiting="isWaiting"
               :error="hasTextfieldError"
               :valid="isTextfieldValid"
               :label="label"
               :label-id="labelId"
               :label-for="id"
               :append="append"
               :focus="isFocus"
               :label-up="labelUp"
               :empty="isEmpty"
               :readonly="isReadonly"
               :required-marker="requiredMarker"
               :tag-style="tagStyle"
               :error-message="errorMessage"
               :valid-message="validMessage"
               :helper-message="helperMessage"
               :style="{ width: inputWidth, maxWidth: inputMaxWidth }"
               @click="onClick">
    <input v-if="!hasWordWrap"
           ref="input"
           :id="id"
           class="m-textfield__input"
           v-model="model"
           :autocomplete="autocomplete"
           :disabled="isDisabled"
           :readonly="isReadonly || isWaiting"
           :placeholder="placeholder"
           :maxlength="maxLengthNumber"
           :type="inputType"
           :aria-invalid="hasTextfieldError"
           :aria-label="inputAriaLabel"
           :aria-describedby="inputAriaDescribedby"
           :aria-activedescendant="inputAriaActivedescendant"
           :aria-autocomplete="inputAriaAutocomplete"
           :aria-controls="inputAriaControls"
           :required="required || requiredMarker"
           :aria-required="required || requiredMarker"
           @blur="onBlur"
           @change="onChange"
           @focus="onFocus"
           @keyup="onKeyup"
           @keydown="onKeydown"
           @paste="onPaste" />
    <template v-if="!hasWordWrap"
              #suffix>
        <transition name="m--is"
                    style="white-space: nowrap;">
            <m-icon-button v-if="passwordIcon && hasValue"
                           class="m-textfield__icon-password"
                           :aria-controls="id"
                           :title="passwordIconDescription"
                           :icon-name="passwordIconName"
                           key="passwordIcon"
                           button-size="22px"
                           @click="togglePasswordVisibility" />
        </transition>
        <slot name="suffix" />
    </template>
    <template slot="append">
        <slot name="append" />
    </template>
    <textarea v-if="hasWordWrap"
              v-model="model"
              v-m-textarea-auto-height
              ref="input"
              :id="id"
              class="m-textfield__input"
              :autocomplete="autocomplete"
              :disabled="isDisabled"
              :readonly="isReadonly || isWaiting"
              :placeholder="placeholder"
              :maxlength="maxLengthNumber"
              :aria-invalid="hasTextfieldError"
              :aria-describedby="inputAriaDescribedby"
              :aria-activedescendant="inputAriaActivedescendant"
              :aria-autocomplete="inputAriaAutocomplete"
              :aria-controls="inputAriaControls"
              :required="required || requiredMarker"
              :aria-required="required || requiredMarker"
              rows="1"
              @focus="onFocus"
              @blur="onBlur"
              @change="onChange"
              @keypress.enter.prevent
              @keyup="onKeyup"
              @keydown="onKeydown"
              @paste="onPaste"></textarea>
    <div slot="validation"
         :id="inputAriaDescribedby"
         class="m-textfield__validation">
        <m-validation-message class="m-textfield__validation-message"
                              :disabled="isDisabled"
                              :waiting="isWaiting"
                              :error="hasTextfieldError"
                              :error-message="errorMessage"
                              :valid="isTextfieldValid"
                              :valid-message="validMessage"
                              :helper-message="helperMessage" />
        <m-character-count v-if="characterCount"
                           class="m-textfield__validation-character-count"
                           :value-length="valueLength"
                           :max-length="maxLength"
                           :threshold="characterCountThreshold" />
    </div>
</m-input-style>
